var map = {
	"./1825238600611532802.png": "8459",
	"./America.png": "6113",
	"./Brazil.png": "ab61",
	"./India.png": "452f",
	"./box-item-icon1.png": "769f",
	"./box-item-icon2.png": "8ac9",
	"./box-item-icon3.png": "2333",
	"./box-item-icon4.png": "f810",
	"./color1.png": "0da0",
	"./comm_icon_gb.png": "27d8",
	"./draw-bottombox.png": "f526",
	"./draw-box.png": "a959",
	"./draw-boxmoney.png": "0272",
	"./draw-gh.png": "2d75",
	"./draw-hand.png": "2829",
	"./draw-topbox.png": "7f7f",
	"./draw_bonus1.png": "f588",
	"./draw_bonus2.png": "5332",
	"./draw_bonus3.png": "74f2",
	"./draw_bonus4.png": "bcb8",
	"./draw_bonus5.png": "f402",
	"./draw_bonus6.png": "300a",
	"./draw_mainbox_bg.png": "e0b6",
	"./draw_point.png": "2e46",
	"./draw_sharebg.png": "6fa3",
	"./draw_temubox.png": "19ae",
	"./draw_temuout1.png": "00e1",
	"./draw_temuout2.png": "0e0e",
	"./game_wt_icon.png": "47b2",
	"./gif_icon.png": "01f6",
	"./h-ac-star.png": "fb0d",
	"./icon_dt_pmd.png": "bdee",
	"./icon_normal_pix.png": "8b77",
	"./img_wa.png": "04c7",
	"./other_wt_icon.png": "13b2",
	"./pay_wt_icon.png": "dd91",
	"./receberbox-gh.png": "2598",
	"./receberbox-light.png": "c64e",
	"./withdraw_wt_icon.png": "02c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "949c";